import { useState } from "react";
import { Navigate,Outlet, useLocation } from "react-router-dom";
import GetCookie from "../hooks/getCookie";
import useAuth from "../hooks/useAuth";


const RequireAuth=({allowedRoles})=> {
     const auth=GetCookie('auth')
    const [user, setUser] = useState(auth?JSON.parse(auth):null);
    const location=useLocation();
    // console.log(user)
    return(
        user?.roles?.find(role=>allowedRoles?.includes(role))
            ?<Outlet/>
            :user
                ?<Navigate to="/unauthorized" state={{from:location}} replace/>
                :<Navigate to="/login" state={{from:location}} replace/>
    )
}
export default RequireAuth;